import GtmService from "../apps/services/gtm.service";
import { Ga4Events } from "../apps/services/models/gtm.models";
import { getButtonClickEvent, getVirtualPayViewEvent } from "../apps/utils/tracking";

export default class MyPageTracking {
    private root: HTMLElement | null;
    private ajaxContent: HTMLElement | null;
    private sidebarMenuItems: NodeListOf<HTMLAnchorElement> | undefined;
    private interactiveContent: NodeListOf<HTMLButtonElement> | undefined;
    private observer: MutationObserver | null = null;

    constructor(element: HTMLElement | null) {
        this.root = element;

        if (this.root === null) return;
        if (this.alreadyInitialized()) return;

        this.ajaxContent = this.root?.querySelector('#ajax-content');
        this.init();
    };
    
    init = () => {
        this.setupSideBarMenuItems();
        this.setupInteractiveContent();    
        this.setupMutationObserver();
    };

    private setupSideBarMenuItems = () => {
        this.sidebarMenuItems = this.root?.querySelectorAll('[data-ajax="true"]');

        this.sidebarMenuItems?.forEach((item) => {
            item.addEventListener('click', () => {
                const url = new URL(item.href, window.location.origin);
                GtmService.pushMypageEvent(Ga4Events.VirtualPageView, getVirtualPayViewEvent(url.pathname, item.textContent || ''));
            });
        });
    };

    private setupInteractiveContent = () => {
        this.interactiveContent = this.ajaxContent?.querySelectorAll('button, a, input[type="button"], input[type="submit"]');
        
        this.interactiveContent?.forEach((item) => {
            item.addEventListener('click', () => {
            const textContent = item.textContent || (item instanceof HTMLInputElement ? item.value : '');
            GtmService.pushMypageEvent(Ga4Events.ButtonClick, getButtonClickEvent(textContent));
            });
        });
    };

    /**
     * Sets up a MutationObserver on the `root` element to monitor changes to its direct children.
     * When a child node is added or removed, the `init` method is called.
     * The observer only watches for changes in the immediate children (not the entire subtree).
     */
    private setupMutationObserver = () => {
        console.log('Setting up MutationObserver for MyPageTracking');
        if (!this.ajaxContent) {
            return;
        }

        this.observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    this.setupInteractiveContent();
                    break;
                }
            }
        });

        this.observer.observe(this.ajaxContent, {
            childList: true,
            subtree: false // Only watch direct children
        });
    };

    /**
     * Checks if the mypage tracking has already been initialized on the root object.
     * If not, marks it as initialized.
     *
     * @returns {boolean} `true` if already initialized, otherwise `false`.
     */
    private alreadyInitialized = () => {
        if ((this.root as any)._mypageTrackingInitialized) {
            return true;
        }
        (this.root as any)._mypageTrackingInitialized = true;
        return false
    }
}